import React from 'react';
import { bannerService } from '../../services/bannerService';
import { getMediaUrl } from '../../services/api';

export default class HeroOne extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            banners: [],
            loading: true
        };
    }

    async componentDidMount() {
        try {
            const res = await bannerService.getPublicBanners('home');
            if (res.success && Array.isArray(res.data)) {
                this.setState({ banners: res.data, loading: false }, () => {
                    this.initCarousel();
                });
            } else {
                this.fallbackBanners();
            }
        } catch (error) {
            console.error('Failed to load home banners:', error);
            this.fallbackBanners();
        }
    }

    fallbackBanners() { this.setState({ banners: [], loading: false }); }

    initCarousel() {
        const $ = window.$;
        if ($ && $('.slider-carousel').length) {
            $('.slider-carousel').trigger('destroy.owl.carousel');
            $('.slider-carousel').owlCarousel({
                animateOut: 'fadeOut',
                animateIn: 'fadeIn',
                loop: true,
                margin: 0,
                nav: false,
                singleItem: true,
                smartSpeed: 500,
                autoplay: true,
                autoplayTimeout: 6000,
                navText: ['<span class="icon-right-arrow"></span>', '<span class="icon-right-arrow"></span>'],
                responsive: {
                    0: { items: 1 },
                    600: { items: 1 },
                    1024: { items: 1 }
                }
            });
        }
    }

    render() {
        const { banners } = this.state;

        return (
            <>
                <section className="slider-one-sec style3" style={{ overflow: "hidden" }}>
                    <div className="slider-carousel owl-carousel owl-theme">
                        {banners.map((banner, index) => {
                            const bgUrl = getMediaUrl(banner.image);

                            const isCenter = banner.alignment === 'center';

                            return (
                                <div className="slider-one__single" key={banner.id || index}>
                                    <div
                                        className="image-layer"
                                        style={{ backgroundImage: `url(${bgUrl})` }}
                                    ></div>
                                    <div className={`container ${isCenter ? 'pl-0' : ''}`}>
                                        <div className="row clearfix">
                                            <div className="col-xl-12">
                                                <div className={`slider-one__single-content ${isCenter ? 'text-center' : ''}`}>
                                                    {banner.subtitle && <h3>{banner.subtitle}</h3>}
                                                    {banner.title && (
                                                        <h2 dangerouslySetInnerHTML={{ __html: banner.title }} />
                                                    )}
                                                    {banner.description && (
                                                        <p dangerouslySetInnerHTML={{ __html: banner.description }} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </>
        );
    }
}
